module.exports = __webpack_public_path__ + "static/media/arrow-right-white.cd90725a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/arrow-right-white.svg
// module id = 1165
// module chunks = 0